// Module
var code = `<div class="js-property-setup-screen">
    <div class="js-left-panel" style="{{#.oneGroup}}display:none;{{/}}">
        <terceraPanel name="leftPanel" />
    </div>
    <terceraSeparator isVertical="true"/>
    <div class="js-right-panel" id="dynpropertyLayoutTable" {{#.oneGroup}}style="left:10px;" {{/}}>
        <div class="js-scrollable-container {{#if .isContainerScreen}}container-screen{{/if}}" >
            <terceraPanel name="rightPanel" />
        </div>
    </div>
</div>`;
// Exports
export default code;